// Treasury → Revenue — section layout.
//
// Revenue grew a second and third page in SM-301, so it follows the
// same shape as the Fees group next door: this file mounts children
// only, and the overview that used to live here now sits in
// treasury.revenue.index.tsx.
//
//   /treasury/revenue                     platform fee revenue (overview)
//   /treasury/revenue/commissions         the admin commission report
//   /treasury/revenue/distributions       commission owed but not posted
//   /treasury/revenue/markets/$marketId   one market's locked terms
//   /treasury/revenue/events/$eventId     one event's child markets
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/treasury/revenue")({
  component: Outlet,
});
